export { default } from './SEO'
